import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport, faAngleDown, faCoins, faUsersRectangle } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import { useEffect, useRef, useState } from "react";
import pathConstant from "../../../../utils/path.constant";

const HrManagementHeader = () => {
    const [showReportDropDown, setShowReportDropDown] = useState<boolean>(false);
    const floatDiv = useRef<HTMLDivElement | null>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (
            !(floatDiv.current?.contains(event.target as Node))
        ) {
          setShowReportDropDown(false);
        }
      };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return(
        <div className="flex p-2 w-full bg-white shadow">
                    <div className="ms-auto flex gap-14 text-lg font-normal text-gray-600 mx-4">
                        <div>
                            <Link to={pathConstant.HR_MANAGEMENT_EMPLOYEE_DATA}>
                                <div className="relative flex gap-1 items-center hr-header-option">
                                    <FontAwesomeIcon icon={faUsersRectangle} />&nbsp;
                                    <h4>Employee Data</h4>
                                </div>
                            </Link>
                        </div>
                        <div>
                            <Link to={pathConstant.HR_MANAGEMENT_LEAVE_CREDITS}>
                                <div className="relative flex gap-1 items-center hr-header-option">
                                    <FontAwesomeIcon icon={faCoins} />&nbsp;
                                    <h4>Leave Credits</h4>
                                </div>
                            </Link>
                        </div>
                        <div className="relative">
                            <div className="relative">
                                <button
                                 onClick={()=>setShowReportDropDown(showReportDropDown ? false : true)}
                                 className="flex justify-center items-center hr-header-option">
                                    <FontAwesomeIcon icon={faFileExport} />&nbsp;
                                    <h4>Extract Reports</h4> &nbsp;
                                    <FontAwesomeIcon icon={faAngleDown} />
                                </button>
                                <div ref={floatDiv} className={showReportDropDown ? "absolute mt-3 w-full" : "hidden"}>
                                    <div className="bg-white shadow-xl border px-2 py-4 text-center">
                                        <Link to={pathConstant.HR_MANAGEMENT_EXTRACT_REPORT_ATTENDANCE_REPORT} className="hover:underline">
                                            <small className="text-md uppercase">
                                                Attendance Report
                                            </small>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    )
}

export default HrManagementHeader;